export default __webpack_public_path__ + "static/media/640_business04-en-mobile.cfa642cf.png";